import authDomain from './auth'
import documentDomain from './document'
import projectDomain from './project'
import registryDomain from './registry'
import teamDomain from './team'

const domains = [
  authDomain,
  documentDomain,
  projectDomain,
  registryDomain,
  teamDomain,
]

export default domains
